import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import loadAffirmScript, { AFFIRM_LOAD_STRATEGY } from 'commons/loadAffirmScript';
const useAffirmScript = t0 => {
  const $ = _c(6);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    onLoad,
    loadStrategy: t2
  } = t1;
  const loadStrategy = t2 === undefined ? AFFIRM_LOAD_STRATEGY.IMMEDIATE : t2;
  let t3;
  let t4;
  if ($[2] !== loadStrategy || $[3] !== onLoad) {
    t3 = () => {
      loadAffirmScript(onLoad, {
        loadStrategy
      });
    };
    t4 = [onLoad, loadStrategy];
    $[2] = loadStrategy;
    $[3] = onLoad;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
};
export { AFFIRM_LOAD_STRATEGY };
export default useAffirmScript;